const context = window as any;

export const hasScannerApi = () => {
  return Boolean(context.QRCode && context.QRCode.postMessage);
};

export const startScan = () => {
  context.QRCode.postMessage('scan');
};

export default {
  hasScannerApi,
  startScan,
};
